import { IState } from 'shared/store';

export const selectBestPlaceAnalyticsReportExampleUrl = (state: IState) => state.rs.bestPlaceAnalyticsReportExampleUrl;
